export let products = (state = products, action) => {
    switch (action.type) {
        case "REQUEST_PRODUCTS":
            return {};
        case "RECEIVE_PRODUCTS":
            return action.products;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/products.js